// to change the links on the downloads page just change the links in the download field
//  the first link in the array maps to the left most icon in the row
export const DATA = [
  {
    study: 1,
    project:
      "Proteome analysis of glandular parotid and submandibular-sublingual saliva in comparison to whole human saliva by two-dimensional gel electrophoresis",
    paper: "https://pubmed.ncbi.nlm.nih.gov/16402355/",
    disease: "Disease Free",
    institution: "University of Regensburg, Germany",
    year: "2006",
    download: [
      "https://s3.amazonaws.com/salivaryproteome.org/hspw-prod-public-data/16402355.csv.gz",
    ],
    available: true,
  },
  {
    study: 2,
    project:
      "The proteomes of human parotid and submandibular/sublingual gland salivas collected as the ductal secretions",
    paper: "https://pubmed.ncbi.nlm.nih.gov/18361515/",
    disease: "Disease Free",
    institution: "University of California, Los Angeles",
    year: "2008",
    download: [
      "https://s3.amazonaws.com/salivaryproteome.org/hspw-prod-public-data/18361515.csv.gz",
    ],
    available: true,
  },
  {
    study: 3,
    project:
      "Alterations in the Salivary Proteome and N-Glycome of Sjögren's Syndrome Patients",
    paper: "https://pubmed.ncbi.nlm.nih.gov/28282148/",
    disease: "Sjögren's Syndrome",
    institution: "University of California, San Francisco​",
    year: "2017",
    download: [
      "https://s3.amazonaws.com/salivaryproteome.org/hspw-prod-public-data/28282148.csv.gz",
    ],
    available: true,
  },
  {
    study: 4,
    project:
      "Cross-Sectional Association of Salivary Proteins with Age, Sex, Body Mass Index, Smoking, and Education",
    paper: "https://pubmed.ncbi.nlm.nih.gov/28481548/",
    disease: "Disease Free",
    institution: "University Medicine Greifswald",
    year: "2017",
    download: [
      "https://s3.amazonaws.com/salivaryproteome.org/hspw-prod-public-data/28481548.csv.gz",
    ],
    available: true,
  },
  {
    study: 5,
    project:
      "Self-Assembled STrap for Global Proteomics and Salivary Biomarker Discovery",
    paper: "https://pubmed.ncbi.nlm.nih.gov/30848925/",
    disease: "Oral Squamous Cell Carcinoma",
    institution: "J. Craig Venter Institute",
    year: "2019",
    download: [
      "https://s3.amazonaws.com/salivaryproteome.org/hspw-prod-public-data/30848925.csv.gz",
    ],
    available: true,
  },
  {
    study: 6,
    project:
      "Mapping Relative Differences in Human Salivary Gland Secretions by Dried Saliva Spot Sampling and nanoLC-MS/MS",
    paper: "https://pubmed.ncbi.nlm.nih.gov/31476108/",
    disease: "Disease Free",
    institution: "The Forsyth Institute",
    year: "2019",
    download: [
      "https://s3.amazonaws.com/salivaryproteome.org/hspw-prod-public-data/31476108.csv.gz",
    ],
    available: true,
  },
  {
    study: 7,
    project:
      "Persistent Immune and Clotting Dysfunction Detected in Saliva and Blood Plasma after COVID-19",
    paper: "https://pubmed.ncbi.nlm.nih.gov/37483779/",
    disease: "COVID-19",
    institution: "J. Craig Venter Institute",
    year: "2022",
    download: [
      "https://s3.us-east-1.amazonaws.com/salivaryproteome.org/hspw-prod-public-data/COVID-19-JCVI-Dataset.csv",
    ],
    available: true,
  },
];
